<template lang="pug">

div( class="ibox" )
  div( class="ibox-content" )
    
    p Contact Details&nbsp;
      a( href="#" v-on:click.prevent="downloadContactCsv" )
        | (Download CSV)
    
    table( class="contact-table" )
      thead
        tr
          th Type
          th Company
          th Contact
      tbody
        tr( v-for="contactDetail in issueReport.contactDetails" )
          td {{ contactDetail.type }}
          td {{ contactDetail.company }}
          td {{ contactDetail.contact }}
        tr
          td( colspan="3" class="text-center" )
            em Following publishers will be automatically contacted if "Send notifications" is checked

</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: [ 'issueReport' ],
  methods: {
    downloadContactCsv() {
      const contactDetails = this.issueReport.contactDetails
      let csv = `Type,Company,Contact\n`
      csv += contactDetails.map((cd) => `${cd.type},${cd.company},${cd.contact}`).join('\n')
      this.$moonpull.downloadFile('text/csv', `contact_details_${this.issueReport.id.substr(-4)}.csv`, csv)
    }
  },
})
</script>
